import { request } from './client.js';

export const extractionApi = {
  extractOnly: (start, end) =>
    request('/api/extraction/extract', {
      method: 'POST',
      body: JSON.stringify({ start_date: start, end_date: end }),
    }),
  processBatch: (batchId) =>
    request('/api/extraction/process', {
      method: 'POST',
      body: JSON.stringify({ batch_id: batchId }),
    }),
  runFull: (start, end) =>
    request('/api/extraction/run', {
      method: 'POST',
      body: JSON.stringify({ start_date: start, end_date: end }),
    }),
  getWatermark: () => request('/api/extraction/watermark'),
  scanDayforce: () => request('/api/extraction/scan-dayforce', { method: 'POST' }),
  getCachedScan: () => request('/api/extraction/scan-dayforce'),
  getBatches: () => request('/api/extraction/batches'),
};
